export interface HighLevelTrailItem {
  label: string;
  page?: string;
}

// Page labels are shared by the clickable trail and the application top bar.
export function highLevelParticipationTrail(page: string, communicationLevel?: string): HighLevelTrailItem[] {
  const teams = {label: 'Teams & children', page: 'squad'};
  const members = {label: 'Team members and allocations', page: 'squad/players'};
  const add = {label: 'Add from schools', page: 'squad/manage'};
  const schools = {label: 'Schools & availability', page: 'schools'};
  switch (page) {
    case 'squad': return [teams];
    case 'squad/players': return [teams, members];
    case 'squad/manage': return [teams, members, add];
    case 'squad/schools': return [teams, members, add, {label: 'Choose recruiting schools'}];
    case 'squad/recruit': return [teams, members, {label: 'Recruit from tournaments'}];
    case 'schools': return [{label: 'Schools & availability'}, {label: 'Represented schools'}];
    case 'schools/availability': return [schools, {label: 'Availability'}];
    case 'schools/notifications': return [schools, {label: 'Notifications'}];
    case 'schools/notification': return [schools, {label: 'Represented schools', page: 'schools'}, {label: 'Send notifications'}];
    case 'communications': return [{label: 'Communications', page: 'communications'}, {label: communicationLevel === 'schools' ? 'With athlete schools' : 'With organiser'}];
    case 'events': return [{label: 'Events'}];
    case 'documents': return [{label: 'Documents'}];
    default: return [{label: 'Overview'}];
  }
}

export const highLevelLegacyPages: Record<string, string> = {
  teams: 'squad', 'teams/edit': 'squad/manage', 'teams/players': 'squad/players',
  'teams/recruit': 'squad/recruit', 'teams/schools': 'squad/schools',
  events: 'events', athleteSchools: 'schools', availability: 'schools/availability',
  'athleteSchools/notification': 'schools/notification', 'athleteSchools/notifications': 'schools/notifications'
};

export function highLevelPageBreadcrumb(pathname: string, search = ''): string | null {
  if (/^\/tournamentAvailability(?:\/|$)/.test(pathname)) {
    const query = new URLSearchParams(search);
    const period = query.get('period') === 'past' ? 'Past' : 'Upcoming';
    const students = period === 'Past' ? 'Students & allocations' : 'Students & availability';
    const section = {documents: 'Documents', communications: 'Communications', availability: students}[query.get('view') || 'availability'] || students;
    return ['Union representation', period, ...(pathname.endsWith('/respond') ? [section] : [])].join(' / ');
  }
  if (!/^\/highLevelTournaments(?:\/|$)/.test(pathname)) return null;
  const path = pathname.replace(/^\/highLevelTournaments\/?/, '').replace(/\/$/, '');
  const lists = {upcoming: 'Upcoming', archive: 'Past', communications: 'Communications'};
  const page = path.startsWith('participation') ? path.replace(/^participation\/?/, '') : highLevelLegacyPages[path];
  const labels = page !== undefined
    ? highLevelParticipationTrail(page, new URLSearchParams(search).get('communicationLevel') || '').map(item => item.label)
    : lists[path] ? [lists[path]] : [];
  return ['High-level tournaments', ...labels].join(' / ');
}
